const POLL_INTERVAL = 500 // ms
const TIMEOUT = 7000 // ms

export function restartWhenStalled(player) {
  let pollId = null // setInterval handle
  let lastBufEnd = 0 // last seen bufferedEnd()
  let lastChangeTime = 0 // ts when bufferedEnd() last moved
  let restartCount = 0

  function clearPoll() {
    if (pollId !== null) {
      clearInterval(pollId)
      pollId = null
    }
  }

  function startPoll() {
    clearPoll()
    lastBufEnd = player.bufferedEnd() // record where the buffer ends now
    lastChangeTime = Date.now()

    pollId = setInterval(function () {
      const bufEnd = player.bufferedEnd()

      // Buffer progressed?  Reset the timer.
      if (bufEnd > lastBufEnd + 0.01) {
        // +0.01s tolerance
        lastBufEnd = bufEnd
        lastChangeTime = Date.now()
        return
      }

      // Has the buffer been stuck for too long?
      if (Date.now() - lastChangeTime >= TIMEOUT) {
        clearPoll()
        restartPlayer()
      }
    }, POLL_INTERVAL)
  }

  function restartPlayer() {
    restartCount += 1
    if (restartCount > 10) return

    const curTime = player.currentTime()
    const curSource = player.currentSource() // {src, type, …}
    const rate = player.playbackRate()
    console.log('RESTART AT', curTime)

    // Full reset wipes all queues & network state
    player.reset()
    player.src(curSource)

    // Once the new source is ready, jump back & play
    player.one('loadedmetadata', function () {
      player.currentTime(curTime)
      player.play()
      player.playbackRate(rate)
    })
    player.play()

    // Important: re-arm the listeners for future stalls
    attachListeners()
  }

  function onWaiting() {
    // Some browsers dispatch multiple 'waiting' events in a row;
    // make sure we aren’t already polling.
    if (pollId === null) {
      startPoll()
    }
  }

  function attachListeners() {
    // Avoid duplicates (e.g. after reset)
    player.off('waiting', onWaiting)
    player.off('playing', clearPoll)
    player.on('waiting', onWaiting)
    player.on('playing', clearPoll)
  }

  attachListeners()
}
